/* ============================================================
   Joraleka — Language Popin (first-visit chooser)  ·  behaviour
   Vanilla JS, 0 dependency. Preserves the production rules
   documented in Confluence 270270467 (origin JOR-269) :

     - Subdomain locale model:
         EN (default) -> https://joraleka.com
         FR           -> https://fr.joraleka.com
     - First-visit trigger: popin opens ONLY when the browser
       language differs from the current domain language.
     - Suggested language (browser) is shown first + highlighted.
     - Switch  -> set shared cookie + redirect to the matching
                  subdomain, preserving the current path.
     - Stay    -> set shared cookie + close (no redirect).
     - Shows once: shared cookie `store_language` on
       domain=.joraleka.com (read across joraleka.com and
       fr.joraleka.com). New / private browser reopens it.
     - Return visit: if the stored language does not match the
       current domain, auto-redirect (no popin).

   Config is read from the root element's data-* attributes
   (set by sections/jor-language-popin.liquid), so nothing is
   hard-coded here.
   ============================================================ */
(function () {
  "use strict";

  var root = document.getElementById("jor-language-popin");
  if (!root) return;

  var CONFIG = {
    current: (root.getAttribute("data-current-lang") || "en").toLowerCase(),
    cookieName: root.getAttribute("data-cookie") || "store_language",
    cookieDomain: root.getAttribute("data-cookie-domain") || "",   // e.g. ".joraleka.com"
    domains: {
      en: root.getAttribute("data-en-domain") || "",
      fr: root.getAttribute("data-fr-domain") || ""
    }
  };

  /* ---------- helpers ---------- */
  function browserLang() {
    // JORS-4384: real browser language captured before the Termly override
    var l = (window.joraBrowserLanguage || navigator.language || navigator.userLanguage || "en").toLowerCase();
    return l.indexOf("fr") === 0 ? "fr" : "en";
  }

  function readCookie(name) {
    var m = document.cookie.match("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)");
    var v = m ? decodeURIComponent(m[1]) : "";
    return v ? v.toLowerCase() : "";
  }

  function readStored() {
    var c = readCookie(CONFIG.cookieName);
    if (c) return c;
    try { return (localStorage.getItem("joraleka_language") || "").toLowerCase(); } catch (e) { return ""; }
  }

  function writeStored(lang) {
    var maxAge = 60 * 60 * 24 * 365; // 12 months
    var cookie = CONFIG.cookieName + "=" + encodeURIComponent(lang) + "; path=/; max-age=" + maxAge + "; SameSite=Lax";
    // Share across joraleka.com + fr.joraleka.com only when actually on that domain
    if (CONFIG.cookieDomain && location.hostname.indexOf("joraleka.com") !== -1) {
      cookie += "; domain=" + CONFIG.cookieDomain;
    }
    if (location.protocol === "https:") cookie += "; Secure";
    try { document.cookie = cookie; } catch (e) {}
    try { localStorage.setItem("joraleka_language", lang); } catch (e) {}
  }

  function domainFor(lang) {
    var d = CONFIG.domains[lang] || "";
    return d.replace(/\/+$/, ""); // trim trailing slash
  }

  // Redirect to the target locale's domain, preserving path + query.
  // No-op (returns false) if we cannot resolve a *different* host.
  function redirectTo(lang) {
    var base = domainFor(lang);
    if (!base) return false;
    var target;
    try { target = new URL(base); } catch (e) { return false; }
    if (target.hostname === location.hostname) return false; // already there
    var dest = target.protocol + "//" + target.host + location.pathname + location.search + location.hash;
    location.href = dest;
    return true;
  }

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- popin open/close ---------- */
  // JORS-4406: texts follow the browser language. Each [data-jlp-t] holds its
  // English and French text in data-en / data-fr (set from the section settings);
  // the server-rendered text is the English one, kept when no French text exists.
  function applyTexts(lang) {
    root.querySelectorAll("[data-jlp-t]").forEach(function (el) {
      var t = el.getAttribute("data-" + lang) || el.getAttribute("data-en");
      if (t) el.textContent = t;
    });
  }

  function openPopin(suggested) {
    applyTexts(suggested);
    // Order: suggested (browser) language first.
    var options = root.querySelector(".jlp-options");
    if (options) {
      var sug = options.querySelector('.jlp-option[data-lang="' + suggested + '"]');
      if (sug) {
        options.insertBefore(sug, options.firstChild);
        sug.classList.add("is-suggested");
        var tag = sug.querySelector(".jlp-tag");
        if (tag) tag.removeAttribute("hidden");
      }
    }
    root.removeAttribute("hidden");
    root.classList.add("is-open");
    document.body.classList.add("jlp-locked");
    var card = root.querySelector(".jlp-card");
    if (card) card.setAttribute("tabindex", "-1"), card.focus();
  }

  function closePopin() {
    root.classList.remove("is-open");
    document.body.classList.remove("jlp-locked");
  }

  // Commit a choice. `action` is "switch" (redirect) or "stay" (close).
  function choose(lang, action, optionEl) {
    writeStored(lang);
    if (optionEl) {
      optionEl.classList.add("is-picked");
      root.querySelectorAll(".jlp-option").forEach(function (el) {
        if (el !== optionEl) el.classList.add("is-dimmed");
        el.disabled = true;
      });
    }
    var commit = function () {
      if (action === "switch") {
        if (redirectTo(lang)) return; // navigating away
      }
      closePopin();
    };
    if (reduceMotion || !optionEl) commit();
    else setTimeout(commit, 380);
  }

  /* ---------- wire option buttons ---------- */
  root.querySelectorAll(".jlp-option").forEach(function (el) {
    el.addEventListener("click", function () {
      var lang = (el.getAttribute("data-lang") || "").toLowerCase();
      if (!lang) return;
      // Clicking the current-domain language = stay; otherwise = switch.
      var action = (lang === CONFIG.current) ? "stay" : "switch";
      choose(lang, action, el);
    });
  });

  // Close (X) / Esc / scrim = keep current language (counts as a choice → shows once).
  function dismiss() { choose(CONFIG.current, "stay", null); }
  var closeBtn = root.querySelector(".jlp-close");
  if (closeBtn) closeBtn.addEventListener("click", dismiss);
  root.addEventListener("mousedown", function (e) { if (e.target === root) dismiss(); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("is-open")) dismiss();
  });

  /* ---------- decide on load ---------- */
  function decide() {
    var stored = readStored();

    if (stored) {
      // Return visit: enforce the saved language across subdomains.
      if (stored !== CONFIG.current) redirectTo(stored);
      return; // never show the popin again
    }

    // No stored choice yet.
    var bl = browserLang();
    if (bl === CONFIG.current) return;            // languages match → no popin
    openPopin(bl);                                // differ → offer the switch
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", decide);
  } else {
    decide();
  }

  // Optional manual hook for QA / re-opening from a link: data-jlp-open
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-jlp-open]");
    if (t) { e.preventDefault(); openPopin(browserLang()); }
  });
})();
